import { Locales } from '@ratehub/base-ui';
import { PAGE_TEMPLATES } from '@ratehub/web-components';

import withEnglishLocale from '../functions/withEnglishLocale';
import createWordpressPageStaticProps from '../functions/createWordpressPageStaticProps';
import createStaticWordpressPage from '../functions/createStaticWordpressPage';
import BLOCK_MAP from '../definitions/TemplateScenarioChooserBlockMap';


const { getStaticPaths, getStaticProps } = createWordpressPageStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'wordpressScenarioChooserEN', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    blockMap: BLOCK_MAP,
    template: PAGE_TEMPLATES.scenarioChooser,

    options: {
        // design requirement: don't show the footer
        footerSettings: {
            isDisabled: true,
            isPopularContentDisabled: true,
        },
    },
});

const page = createStaticWordpressPage({ blockMap: BLOCK_MAP });

export default withEnglishLocale(page);
export { getStaticPaths, getStaticProps };
